import { render, staticRenderFns } from "./themeFarmhouse.vue?vue&type=template&id=612585ea&scoped=true&"
import script from "./themeFarmhouse.vue?vue&type=script&lang=js&"
export * from "./themeFarmhouse.vue?vue&type=script&lang=js&"
import style0 from "./themeFarmhouse.vue?vue&type=style&index=0&id=612585ea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612585ea",
  null
  
)

export default component.exports